import type { Messages } from '../types';

const es: Messages = {
  'meta.homeTitle': 'Calendario imprimible gratis - Calendarify',
  'meta.homeDescription':
    'Calendarios imprimibles gratis online. Elige cualquier mes, personaliza el diseño e imprime tu calendario gratis con Calendarify — sin registro.',
  'meta.twitterTitle': 'Calendario imprimible gratis - Calendarify',
  'meta.twitterDescription':
    'Calendarios imprimibles gratis online. Personaliza un calendario mensual e imprímelo gratis — rápido, sencillo y sin descargas.',
  'meta.supportTitle': 'Ayuda - Calendarify',
  'meta.supportDescription':
    'Ayuda con Calendarify: imprimir desde el móvil, guardar como PDF y usar calendarios en tablets como ReMarkable o BOOX.',
  'meta.printTitle': 'Calendario mensual imprimible gratis - Calendarify',
  'meta.printDescription':
    'Imprime un calendario mensual gratis online. Personaliza colores y notas, e imprime tu calendario gratis con Calendarify.',
  'meta.printMonthTitle': 'Calendario {month} {year} - Calendarify',
  'meta.printMonthDescription':
    'Calendario imprimible gratis de {month} {year} online. Personaliza colores, añade notas e imprime tu calendario mensual gratis.',

  'header.subtitle': 'Calendarios imprimibles gratis online',
  'nav.home': 'Inicio',
  'nav.support': 'Ayuda',
  'nav.menu': 'Menú',
  'nav.language': 'Idioma',

  'footer.rights': 'Todos los derechos reservados.',

  'home.intro':
    'Elige un mes abajo, personaliza el aspecto e imprime tu calendario gratis — sin registro ni apps.',
  'home.customMonth': 'Mes personalizado',
  'home.go': 'Ir',

  'print.tip':
    'Haz clic en "Configurar" para cambiar el aspecto de tu calendario. Puedes ver una vista previa al final de esta página. También puedes hacer clic en cualquier día de la vista previa para añadir tu propio texto antes de imprimir.',
  'print.invalidUrl': 'URL de calendario no válida',
  'print.h1Fallback': 'Imprimir un calendario - Calendario mensual imprimible gratis',
  'print.monthHeading': 'Calendario imprimible de {month} {year}',

  'printer.configure': 'Configurar',
  'printer.printCalendar': 'Imprimir calendario',
  'printer.theme': 'Tema',
  'printer.grid': 'Cuadrícula',
  'printer.gridStyle': 'Estilo de cuadrícula:',
  'printer.lineWidth': 'Grosor de línea (px):',
  'printer.lineColor': 'Color de línea:',
  'printer.fontColor': 'Color de fuente:',
  'printer.weekend': 'Fin de semana:',
  'printer.holiday': 'Festivo:',
  'printer.weekStartsOn': 'La semana empieza el:',
  'printer.showCountryHolidays': 'Mostrar festivos del país:',
  'printer.showSidebar': 'Mostrar barra lateral:',
  'printer.showFootnotes': 'Mostrar notas al pie:',
  'printer.sideNotes': 'Notas laterales',
  'printer.footnotes': 'Notas al pie',
  'printer.gridRectangle': 'Rectangular',
  'printer.gridRounded': 'Redondeada',
  'printer.gridMinimal': 'Minimalista',
  'printer.monday': 'Lunes',
  'printer.sunday': 'Domingo',
  'printer.none': 'Ninguno',
  'printer.canada': 'Canadá',
  'printer.mexico': 'México',
  'printer.uk': 'Reino Unido',
  'printer.usa': 'EE. UU.',

  'support.intro':
    'Gracias por usar Calendarify. Si hay alguna función adicional que te ayude con tus necesidades de calendario, nos gustaría saberlo.',
  'support.cta': 'Envía tu idea a:',
  'support.faqHeading': 'Preguntas frecuentes',
  'support.qMobile': '¿Puedo imprimir desde un dispositivo móvil?',
  'support.aMobile':
    'Sí, aunque algunos dispositivos no muestran el tamaño del calendario correctamente. En ese caso, suele bastar con ajustar la "escala" en el diálogo de vista previa de impresión para que todo quepa en una página.',
  'support.qPdf': '¿Puedo guardar el calendario como PDF?',
  'support.aPdf':
    'Sí, normalmente puedes hacerlo haciendo clic en "Imprimir" y luego eligiendo "Imprimir como PDF" en el diálogo de vista previa.',
  'support.qTablet': '¿Puedo usar estos calendarios en mi ReMarkable, BOOX u otra tableta?',
  'support.aTablet':
    'Por supuesto: imprime como PDF y sube ese archivo a tu tableta (en ReMarkable puedes subir archivos desde su sitio web; en otros dispositivos puedes usar un servicio de archivos como Google Drive).',

  'months.january': 'Enero',
  'months.february': 'Febrero',
  'months.march': 'Marzo',
  'months.april': 'Abril',
  'months.may': 'Mayo',
  'months.june': 'Junio',
  'months.july': 'Julio',
  'months.august': 'Agosto',
  'months.september': 'Septiembre',
  'months.october': 'Octubre',
  'months.november': 'Noviembre',
  'months.december': 'Diciembre',

  'weekdays.sun': 'Dom',
  'weekdays.mon': 'Lun',
  'weekdays.tue': 'Mar',
  'weekdays.wed': 'Mié',
  'weekdays.thu': 'Jue',
  'weekdays.fri': 'Vie',
  'weekdays.sat': 'Sáb',
};

export default es;
